import { trimSearch } from '@xmatters/common/utils/searchUtil';

export const getUsersBySearchAction = type => search => {
  const usersUri = '/webapi/xm/1/people';
  const params = {};

  const trimmedSearchText = trimSearch(search);
  if (trimmedSearchText.length >= 2) {
    params.search = trimmedSearchText;
    params.operand = 'AND';
    params.fields = ['FIRST_NAME', 'LAST_NAME', 'TARGET_NAME'];
  }

  return {
    type,
    meta: {
      xmApi: true,
      method: 'get',
      uri: usersUri,
      params,
    },
  };
};
